let pageConfig = {};

// 共享充电订单 - 列表展示项
pageConfig.listColumns = [
  {
    label: "共享充电订单ID",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "关联预约订单ID",
    props: "reserveOrderNo",
    minWidth: 280,
  },
  {
    label: "订单属性",
    props: "shareOrderTypeName",
    minWidth: 180,
  },
  {
    label: "异常原因",
    props: "abnormalReason",
    minWidth: 150,
  },
  {
    label: "订单类型",
    props: "orderPropertyName",
    minWidth: 180,
  },
  {
    label: "共享设备类型",
    props: "deviceTypeName",
    minWidth: 280,
  },
  {
    label: "充电设备编号/IMEI",
    props: "pileCode",
    minWidth: 200,
  },
  {
    label: "站点名称",
    props: "stationName",
    minWidth: 180,
  },
  {
    label: "充电业务归属",
    props: "bindSourceName",
    minWidth: 150,
  },
  {
    label: "充电用户账号类型",
    props: "custTypeName",
    minWidth: 150,
  },

  {
    label: "桩主用户手机号",
    props: "custMobile",
    minWidth: 150,
  },
  {
    label: "充电用户手机号",
    props: "custPhone",
    minWidth: 150,
  },

  {
    label: "共享充电类型",
    props: "shareStartTypeName",
    minWidth: 150,
  },
  {
    label: "订单状态",
    props: "shareOrderStatusName",
    minWidth: 150,
  },

  {
    label: "结算方式",
    props: "abnormalHandleName",
    minWidth: 150,
  },

  {
    label: "结算类型",
    props: "settleTypeName",
    minWidth: 150,
  },

  {
    label: "订单属性",
    props: "orderPropertyName",
    minWidth: 200,
  },
  {
    label: "手机号",
    props: "custPhone",
    minWidth: 200,
  },
  {
    label: "开始时间",
    props: "beginTime",
    minWidth: 200,
  },
  {
    label: "启动充电时间",
    props: "startChargingTime",
    minWidth: 200,
  },
  {
    label: "结束时间",
    props: "endTime",
    minWidth: 200,
  },
  {
    label: "结束方式",
    props: "chargeOverReason",
    minWidth: 200,
  },
  {
    label: "充电时长",
    props: "chargeMinDesc",
    minWidth: 200,
  },
  {
    label: "充电电量(kwh)",
    props: "chargeVal",
    minWidth: 200,
  },
  {
    label: "充电预付费用（元）",
    props: "prePayFee",
    minWidth: 200,
  },
  {
    label: "充电实付费用（元）",
    props: "actPayFee",
    minWidth: 200,
  },
  {
    label: "平台服务费（元）",
    props: "servFee",
    minWidth: 200,
  },
  {
    label: "支付手续费（元）",
    props: "huifuPaymentFee",
    minWidth: 200,
  },
  {
    label: "已退预付费用（元）",
    props: "preAmtPayFee",
    minWidth: 200,
  },
  {
    label: '已退实收费用（元）',
    props: "actAmtPayFee",
    minWidth: 200,
  },
  {
    label: "预付退款状态",
    props: "transStatusName",
    minWidth: 200,
  },
  {
    label: "预付退款完成时间",
    props: "transFinishedTime",
    minWidth: 200,
  },
  {
    label: "更新人",
    props: "lastModifiedByName",
    minWidth: 200,
  },
  {
    label: "更新时间",
    props: "lastModifiedWhen",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
];

// 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "订单管理",
  },
  {
    type: "title",
    name: "个人站共享订单",
  },
  {
    type: "title",
    name: "共享充电订单",
  },
];

pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};

pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "pileDetail",
};

pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "订单管理",
  },
  {
    type: "title",
    name: "个人站共享订单",
  },
  {
    type: "title",
    name: "共享充电订单",
  },
  {
    type: "title",
    name: "订单详情",
  },
];

export default pageConfig;
